export default __webpack_public_path__ + "static/map-59a63a6f6ad592f9fa92cc6b70acdc17.jpg";